import { Controller } from "@hotwired/stimulus";
import { validateMessage } from "../lib/cardMessageConstraints";

export default class extends Controller {
  static targets = ["continue", "count", "message", "warning"];

  connect() {
    this.update();
  }

  update() {
    const message = this.messageTarget.value;
    const validation = validateMessage({ text: message }, 1);
    const empty = message.trim() === "";
    this.valid = !empty && validation.fits;

    this.countTarget.textContent = `${validation.usedLines}/${validation.maxLines} print lines used`;
    this.countTarget.classList.toggle("text-gray-400", validation.fits);
    this.countTarget.classList.toggle("text-red-600", !validation.fits);
    this.messageTarget.setAttribute("aria-invalid", String(!this.valid));
    this.warningTarget.classList.toggle("hidden", this.valid);
    this.warningTarget.textContent = empty
      ? "Message is required."
      : validation.fits
        ? ""
        : `${Math.abs(validation.remainingLines)} lines over. Shorten this message so it fits in the card.`;
    this.continueTarget.setAttribute("aria-disabled", String(!this.valid));
  }

  proceed(event) {
    if (!this.valid) event.preventDefault();
  }
}
